<template>
  <b-container>
    <!-- {{moduleId}} -->
      <pendencies-opened :moduleId="moduleId"> </pendencies-opened>
 </b-container>
</template>
<script>
export default {
  name: "ModulePendenciesOpned",
  props:{
    moduleId: String
  },
  components: {
    PendenciesOpened: () => import("src/pagesRms/checklist/pendency/PendenciesOpened.vue")
  },
};
</script>
